enum BillingType {
    Direct = "DIRECT",
    Indirect = "INDIRECT",
    Stores = "STORES",
}

export default BillingType;
